import { eventDispatcherConfig } from './PortalValuePropPage.analytics'

import { PageSuffix } from '@/constants/errors/suffix'
import { registerPage } from '@/utils/register-page'

export const PortalValuePropContract = registerPage({
  suffix: PageSuffix.PORTAL_VALUE_PROP,
  shouldRenderFactory: () => import('./helpers/should-render'),
  pageFactory: () => import('./PortalValuePropPage'),
  analyticsConfig: () => eventDispatcherConfig().config,
})
